// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"e_1h","wrapperDark":"e_2h","wrapperLight":"e_3h"};